import { observer } from 'mobx-react-lite';
import { Callout } from '@fluentui/react/lib/Callout';
import loc from 'owa-localize';
import {
    getScenarioStore,
    getSearchBoxIdByScenarioId,
    is3SServiceAvailable,
    SearchBox,
    SearchScenarioId,
} from 'owa-search';
import * as React from 'react';
import { getStore } from '../store/store';
import { fileSearchBoxPlaceholder, noResultsFound2 } from './FileSearchBox.locstring.json';

const styles = require('./FileSearchBox.scss');
const classNames = require('classnames/bind').bind(styles);

const FileSearchBox = observer(function FileSearchBox() {
    const isUsing3S = is3SServiceAvailable();

    const isSuggestionsDropdownVisible = getScenarioStore(SearchScenarioId.FileSuggestions)
        .isSuggestionsDropdownVisible;
    const currentSuggestions = getScenarioStore(SearchScenarioId.FileSuggestions)
        .currentSuggestions;

    return (
        <>
            <SearchBox
                isUsing3S={isUsing3S}
                scenarioId={SearchScenarioId.FileSuggestions}
                searchPlaceHolderText={loc(fileSearchBoxPlaceholder)}
                customCollapsedMaxWidth={getStore().searchBoxWidth}
            />
            {isSuggestionsDropdownVisible && currentSuggestions?.Suggestions.length === 0 && (
                <Callout
                    className={styles.callout}
                    gapSpace={1}
                    isBeakVisible={false}
                    target={`#${getSearchBoxIdByScenarioId(SearchScenarioId.FileSuggestions)}`}>
                    <div className={styles.container}>
                        <div className={classNames(styles.textContainer, styles.centered)}>
                            {loc(noResultsFound2)}
                        </div>
                    </div>
                </Callout>
            )}
        </>
    );
});

export default FileSearchBox;
